/*
 * Central collection of Z_INDEX values around the platform.
 * Keeping a central file assists in tracking down overlapping issues.
 */
export const Z_INDEX_DICT = {
  LEAD_TABLE_LEFT_COLUMN_BODY: '8',
  LEAD_TABLE_LEFT_COLUMN_HEADER: '10',
  LEAD_TABLE_HEADER: '9',
  COMPANY_DETAILS_MENU: '2',
  COMPANY_FILTERS_MENU: '11',
  DOCUMENT_FILTERS_MENU: '11',
  DROPDOWN: '1',
  MAP_SEARCH_INPUT: '102',
  DRAWN_POLYGON: '998',
  SELECTED_POLYGON: '999',
  MAP_SIDEBAR: '1',
  MAP_MAIN_CONTENT: '0',
  // Mobile filter drawer (SidebarLayout) — layered above page/map content so
  // the overlay drawer and its backdrop sit on top of everything below it.
  MOBILE_FILTER_BACKDROP: '1001',
  MOBILE_FILTER_DRAWER: '1002',
};
